import { Property, Apartment } from '../../lib/api';

export interface EditApartmentForm {
  id: string;
  property_id?: string;
  organization_id?: string;
  apartment_number?: string;
  floor: string | number;
  dwelling_type?: string;
  area_sqm: string | number;
  storage_units: string[];
  residents?: ResidentData[];
  resident_count?: number;
}

export interface ResidentData {
  id: string;
  name?: string;
  first_name?: string;
  last_name?: string;
  email?: string;
  phone?: string;
  personal_number?: string;
  role?: string;
}

export interface EditResidentForm {
  id: string;
  first_name: string;
  last_name: string;
  email: string;
  phone: string;
  personal_number: string;
  role: 'superadmin' | 'admin' | 'auditor' | 'suppliant' | 'board_member' | 'resident' | 'supplier' | 'external';
}

export interface NewApartmentForm {
  property_id: string;
  apartment_number: string;
  floor: string;
  dwelling_type: string;
  area_sqm: string;
  storage_units: string[];
}

export interface NewResidentForm {
  first_name: string;
  last_name: string;
  email: string;
  phone: string;
  personal_number: string;
  role: 'superadmin' | 'admin' | 'auditor' | 'suppliant' | 'board_member' | 'resident' | 'supplier' | 'external';
}

// Format phone number: xx-xxx xx xx or xxx-xxx xx xx
export const formatPhoneNumber = (value: string | undefined): string => {
  if (!value) return '';
  const cleaned = value.replace(/\D/g, '');
  if (cleaned.length <= 2) return cleaned;
  if (cleaned.length <= 5) return `${cleaned.slice(0, 2)}-${cleaned.slice(2)}`;
  if (cleaned.length <= 7) return `${cleaned.slice(0, 2)}-${cleaned.slice(2, 5)} ${cleaned.slice(5)}`;
  if (cleaned.length <= 9) return `${cleaned.slice(0, 2)}-${cleaned.slice(2, 5)} ${cleaned.slice(5, 7)} ${cleaned.slice(7)}`;
  // For longer numbers (like 07x-xxx xx xx)
  if (cleaned.length === 10) return `${cleaned.slice(0, 3)}-${cleaned.slice(3, 6)} ${cleaned.slice(6, 8)} ${cleaned.slice(8)}`;
  return cleaned;
};

export const DWELLING_TYPES = [
  { value: 'apartment', label: 'Lägenhet' },
  { value: 'townhouse', label: 'Radhus' },
  { value: 'studio', label: 'Etta' }
];

export const RESIDENT_ROLES = [
  { value: 'owner', label: 'Ägare' },
  { value: 'tenant', label: 'Hyresgäst' },
  { value: 'family', label: 'Familjemedlem' }
];

export type { Property, Apartment };
